import { createFileRoute, redirect } from "@tanstack/react-router";
import { EditTemplateForm } from "@/features/consent-solutions";
import { PreviewContextProvider } from "@/features/consent-solutions/contexts/popup-preview-context";
import { FormActions } from "@/features/consent-solutions/features/pop-up-templates/types/edit-template-form";
import { checkUserPermissions } from "@/features/auth";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";

export const Route = createFileRoute(
  "/_authorized/consent-solutions/$csId/popup_/edit-template/$templateId/$templateAction/",
)({
  beforeLoad: ({ context, params }) => {
    const { userDetails } = context as AuthorizedRouteContext;
    const { csId, templateAction } = params;

    const permissionToActionMap: Record<FormActions, Parameters<typeof checkUserPermissions>[1]> = {
      edit: ["POPUP_TEMPLATE_EDIT"],
      "create-from-template": ["POPUP_TEMPLATE_CREATE"],
      clone: ["POPUP_TEMPLATE_CREATE"],
    };

    const requiredPermission = permissionToActionMap[templateAction as FormActions];

    const isUserPermitted = checkUserPermissions(userDetails, requiredPermission, csId);

    if (requiredPermission && !isUserPermitted) {
      redirect({
        to: "/consent-solutions/$csId/popup/my-templates",
        params: { csId },
        replace: true,
        throw: true,
      });
    }
  },
  component: () => (
    <PreviewContextProvider>
      <EditTemplateForm />
    </PreviewContextProvider>
  ),
});
